import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { toast } from 'react-toastify';
import axios from 'helpers/api';
import * as mapYourMedsConstant from '../../../common/mapYourMedsConstant.js';

const MedRecordCategoryForm = (props) => {
    const initialFormData = {
        id: '',
        code: '',
        facilityname: '',
        description: "",
        is_medsheet: true,
        is_treatment: true,
        is_physpres: true,
        is_active: true
    };

    const [formData, setFormData] = useState(initialFormData);
    const formRef = useRef(null);
    const [buttonStatus, setButtonStatus] = useState(mapYourMedsConstant.ADD_ACTION);

    useEffect(() => {
        const item = props.medrecval || props.dataObj;
        if (item && (item.id || item.mc_id || item.category_id)) {
            setFormData({
                id: item.id || item.mc_id || item.category_id || '',
                code: item.code || '',
                facilityname: item.facilityname || '',
                description: item.description || '',
                is_medsheet: item.mar_flag === 'Y' || item.mar_flag == 1 || item.mar_flag === true || item.is_medsheet === true,
                is_treatment: item.tar_flag === 'Y' || item.tar_flag == 1 || item.tar_flag === true || item.is_treatment === true,
                is_physpres: item.po_flag === 'Y' || item.po_flag == 1 || item.po_flag === true || item.is_physpres === true,
                is_active: item.is_active == 1 || item.is_active === '1' || item.is_active === true
            });
            setButtonStatus(mapYourMedsConstant.UPDATE_ACTION);
        } else {
            setFormData(initialFormData);
            setButtonStatus(mapYourMedsConstant.ADD_ACTION);
        }
    }, [props.edittrigger, props.medrecval, props.dataObj]);

    const isAddMode = buttonStatus === "Add" || buttonStatus === mapYourMedsConstant.ADD_ACTION;

    const handleSubmit = async e => {
        e.preventDefault();

        let tokenStr = localStorage.getItem("accessToken");

        let pelmedsMedRecCatUrl = isAddMode ? `${process.env.REACT_APP_SERVER_URL}/patients/add-medical-record-category` :
            `${process.env.REACT_APP_SERVER_URL}/patients/update-medical-record-category`;

        let pelmedsMedRecCatData = isAddMode ?
            {
                "group_id": localStorage.getItem("groupId") || '',
                "code": formData.code,
                "description": formData.description,
                "mar_flag": formData.is_medsheet ? 1 : 0,
                "tar_flag": formData.is_treatment ? 1 : 0,
                "po_flag": formData.is_physpres ? 1 : 0,
                "is_active": 1
            } :
            {
                "id": formData.id,
                "group_id": localStorage.getItem("groupId") || '',
                "code": formData.code,
                "description": formData.description,
                "mar_flag": formData.is_medsheet ? 1 : 0,
                "tar_flag": formData.is_treatment ? 1 : 0,
                "po_flag": formData.is_physpres ? 1 : 0,
                "is_active": formData.is_active ? 1 : 0
            };

        try {
            const { data } = await axios.post(pelmedsMedRecCatUrl, pelmedsMedRecCatData, { headers: { 'Authorization': `Bearer ${tokenStr}` } });

            if (data.status) {
                toast.success(isAddMode ? "Medical Record Category added successfully" : "Medical Record Category updated successfully", { autoClose: 3000 });
            }
            else {
                toast.info(data.message || "Error while adding/updating Medical Record Category", { autoClose: 3000 });
            }
        } catch (error) {
            toast.error("Error submitting Medical Record Category");
        }

        setFormData(initialFormData);
        if (formRef.current) {
            formRef.current.reset();
        }
        setButtonStatus(mapYourMedsConstant.ADD_ACTION);

        if (props.onCallParent) {
            props.onCallParent();
        }
    };

    const handleFieldChange = e => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    return (
        <Form ref={formRef} onSubmit={handleSubmit}>
            <Row>
                <Col xs={6}>
                    <Form.Group className="mb-3">
                        <Form.Label className="required">Code</Form.Label>
                        <Form.Control
                            placeholder='Code'
                            value={formData.code}
                            size="sm"
                            name="code"
                            onChange={handleFieldChange}
                            type="text"
                        />
                    </Form.Group>
                </Col>
                <Col xs={6}>
                    <Form.Group className="mb-3">
                        <Form.Label className="required">Description</Form.Label>
                        <Form.Control
                            placeholder='Description'
                            size="sm"
                            value={formData.description}
                            name="description"
                            onChange={handleFieldChange}
                            type="text"
                        />
                    </Form.Group>
                </Col>
            </Row>
            <Row className="mb-2">
                <Col>
                    <Form.Check
                        type='switch'
                        name="is_medsheet"
                        id='is_medsheet'
                        checked={formData.is_medsheet}
                        onChange={e =>
                            setFormData({
                                ...formData,
                                is_medsheet: e.target.checked
                            })
                        }
                        label='Medsheet'
                    />
                </Col>
                <Col>
                    <Form.Check
                        type='switch'
                        name="is_treatment"
                        id='is_treatment'
                        checked={formData.is_treatment}
                        onChange={e =>
                            setFormData({
                                ...formData,
                                is_treatment: e.target.checked
                            })
                        }
                        label='Treatment'
                    />
                </Col>
                <Col>
                    <Form.Check
                        type='switch'
                        name="is_physpres"
                        id='is_physpres'
                        checked={formData.is_physpres}
                        onChange={e =>
                            setFormData({
                                ...formData,
                                is_physpres: e.target.checked
                            })
                        }
                        label='Physician Prescription'
                    />
                </Col>
            </Row>

            <Row className="mb-3">
                <Col xs={12}>
                    <Form.Check
                        type='switch'
                        id='is_active'
                        name="is_active"
                        checked={isAddMode ? true : formData.is_active}
                        disabled={isAddMode}
                        onChange={e =>
                            setFormData({
                                ...formData,
                                is_active: e.target.checked
                            })
                        }
                        label='Active'
                    />
                </Col>
            </Row>

            <Row>
                <Col xs={6}>
                    <Form.Group>
                        <Button
                            type="submit"
                            color="primary"
                            className="mt-1 w-50"
                            size="sm"
                            disabled={!formData.code || !formData.description}>
                            {buttonStatus}
                        </Button>
                    </Form.Group>
                </Col>
            </Row>
            <Row className="mt-2">
                <Col>
                    <Form.Label><span className="text-danger">*</span> indicates required field</Form.Label>
                </Col>
            </Row>
        </Form>
    );
};

MedRecordCategoryForm.propTypes = {
    medrecval: PropTypes.any,
    dataObj: PropTypes.any,
    edittrigger: PropTypes.number,
    onCallParent: PropTypes.func
};

export default MedRecordCategoryForm;
